import { useQuery } from "@tanstack/react-query";
import {
  fetchEntityFollowers,
  fetchEntityFollowing,
  getEntityFollowersList,
  getEntityFollowingList,
} from "../../services/entities";
import { fetchUserFollowers, fetchUserFollowing, getFriends } from "../../services/users";
import { useTranslation } from "react-i18next";

type UseNetworkListParams = {
  tabValue: number;
  roleTab: number;
  finalEntityId: number;
  userParamId?: string;
  location?: string;
  nationality?: string;
  gender?: string;
  verificationStatus?: string;
  roleEntitySelected?: string;
  networkFilters?: any;
  page: number;
};

const useNetworkList = ({
  tabValue,
  roleTab,
  finalEntityId,
  userParamId,
  location,
  nationality,
  gender,
  verificationStatus,
  roleEntitySelected,
  networkFilters,
  page,
}: UseNetworkListParams) => {
  const { i18n } = useTranslation();

  const fetchNetworkList = () => {
    if (tabValue === 0) {
      if (roleTab === 6) {
        return getEntityFollowersList(finalEntityId, 12, page);
      }
      if (userParamId) {
        return fetchUserFollowers(
          finalEntityId,
          12,
          page,
          location,
          nationality,
          gender,
          verificationStatus,
          roleEntitySelected,
          null,
          networkFilters
        );
      } else {
        return fetchEntityFollowers(
          finalEntityId,
          12,
          page,
          location,
          nationality,
          gender,
          verificationStatus,
          roleEntitySelected,
          null,
          networkFilters
        );
      }
    } else if (tabValue === 1) {
      if (roleTab === 6) {
        return getEntityFollowingList(finalEntityId, 12, page);
      }
      if (userParamId) {
        return fetchUserFollowing(
          finalEntityId,
          12,
          page,
          location,
          nationality,
          gender,
          verificationStatus,
          roleEntitySelected,
          null,
          networkFilters
        );
      } else {
        return fetchEntityFollowing(
          finalEntityId,
          12,
          page,
          location,
          nationality,
          gender,
          verificationStatus,
          roleEntitySelected,
          null,
          networkFilters
        );
      }
    } else {
      return getFriends(
        finalEntityId,
        12,
        page,
        location,
        nationality,
        gender,
        verificationStatus,
        roleEntitySelected,
        null,
        networkFilters
      );
    }
  };

  const { data, isLoading, error } = useQuery({
    queryKey: [
      "NetworkList",
      i18n.language,
      finalEntityId,
      userParamId,
      tabValue,
      page,
      location,
      nationality,
      gender,
      verificationStatus,
      roleEntitySelected,
      networkFilters,
      roleTab,
    ],
    queryFn: fetchNetworkList,
  });

  return { networkDataResults: data, isNetworkDataLoading: isLoading, isNetworkDataHasError: error };
};

export default useNetworkList;
